import { environment } from '@/shared/enviroment/environment';
import { ApiService } from '@/shared/service/Apiservice';
import axios from 'axios';

export interface ProductDetail {
	_id: string;
	title: string;
	slug: string;
	price: number;
	description?: string;
	imageUrl?: string;
	variants?: any[];
	categories?: Array<{ _id: string; name: string; slug: string }>;
}

export interface ProductDetailResponse {
	success: boolean;
	data: ProductDetail;
}

class ProductDetailService {
	private apiRootServer = environment.api.apiRootServer;
	private __Apiservice: ApiService;

	constructor() {
		const axiosInstance = axios.create();
		this.__Apiservice = new ApiService(axiosInstance, this.apiRootServer);
	}

	async getProductDetail(slug: string): Promise<ProductDetailResponse> {
		return this.__Apiservice.getRequest(`products/${slug}`, {}, {
			apiRoot: this.apiRootServer,
		});
	}
}

const productDetailService = new ProductDetailService();
export default productDetailService;
